import { InspectionModel } from 'shared/domain/inspection/inspectionModel';

/**
 * Resolve protocol section id from either protocol section id or checklist section id.
 */
export function resolveProtocolSectionId(
  inspectionModel: InspectionModel | undefined,
  sectionKeyId: string
): string | undefined {
  const section = inspectionModel?.sections?.find(
    (item) =>
      item._id === sectionKeyId ||
      item.checklistSectionId === sectionKeyId
  );

  return section?._id;
}

/**
 * Id used for section batch operations (N/A toggle, answers/batch).
 * Falls back to the checklist section id when no protocol section exists yet.
 */
export function resolveSectionBatchKeyId(
  inspectionModel: InspectionModel | undefined,
  sectionKeyId: string
): string {
  return resolveProtocolSectionId(inspectionModel, sectionKeyId) ?? sectionKeyId;
}